import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/fly.png'


const _hoisted_1 = { class: "_modal bg-white" }
const _hoisted_2 = { class: "_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "150",
    width: "150"
  })
], -1)
const _hoisted_4 = {
  key: 0,
  class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-green-500" }
const _hoisted_9 = {
  key: 1,
  class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
}
const _hoisted_10 = {
  key: 2,
  class: "text-center text-neutral-500 mt-2"
}
const _hoisted_11 = {
  key: 3,
  class: "w-full mt-5"
}
const _hoisted_12 = { class: "input-group grid grid-cols-2 items-center" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Họ và Tên ", -1)
const _hoisted_14 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_15 = { class: "input-group grid grid-cols-2 items-center mt-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Báo cáo ", -1)
const _hoisted_17 = {
  key: 0,
  class: "font-bold text-neutral-500 text-right"
}
const _hoisted_18 = { class: "text-green-500" }
const _hoisted_19 = {
  key: 0,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Ngày nộp báo cáo ", -1)
const _hoisted_21 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_22 = {
  key: 1,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Kế hoạch tiếp theo ", -1)
const _hoisted_24 = { class: "font-bold text-green-500 text-right" }
const _hoisted_25 = { class: "text-green-500" }
const _hoisted_26 = {
  key: 2,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-500 font-normal" }, " Ngày áp dụng dự kiến ", -1)
const _hoisted_28 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_29 = {
  key: 3,
  class: "input-group grid grid-cols-2 items-center mt-10"
}
const _hoisted_30 = { class: "input-group__label text-neutral-500 font-normal" }
const _hoisted_31 = { class: "font-bold text-neutral-500 text-right" }
const _hoisted_32 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.successData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(" Báo cáo " + _toDisplayString(_ctx.$filters.terminology('plan')) + " đã hoàn thành. ", 1),
            _hoisted_5,
            _createTextVNode("Bạn có muốn tiếp tục làm " + _toDisplayString(_ctx.$filters.terminology('plan')) + " ", 1),
            _hoisted_6,
            (_ctx.reportData.report_name_next)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.reportData.report_name_next), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " Hoàn thành báo cáo ")),
      (_ctx.successData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Bạn có thể chỉnh sửa Kế hoạch này sau ở mục Kế hoạch "))
        : _createCommentVNode("", true),
      (!_ctx.successData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              (_ctx.reportData?.student)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.reportData.student), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              (_ctx.reportData?.report_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.reportData.report_name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.reportData?.inserted_at)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.formatDate(_ctx.reportData.inserted_at)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.reportData?.report_name_next)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.reportData.report_name_next), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.reportData?.report_date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.applyDateText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.reportData?.staff)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$filters.terminology('teacher')) + " làm báo cáo ", 1),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.reportData.staff), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_32, [
      (!_ctx.successData)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, " Quay lại "))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close-complete')))
          }, " Làm sau ")),
      (_ctx.successData)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('doNextPlan')))
          }, " Tiếp tục "))
        : (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "button-p text-center whitespace-nowrap",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
          }, " Xác nhận "))
    ])
  ]))
}